import { getlobbyGridData } from "./../state/selectors/lobby-staff-status.selector";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, of, Subscription } from "rxjs";
import {
  getAvailableActiveBranches,
  getCurrentTenant,
  getIsConnectionStarted,
  getLobbyLocationSelctorStatus,
  getLobbyLocationSelected,
  getLobbyShowCategory,
  getLoggedInUserId,
  getLoggedInUserInfo,
  getLoggedInUserNotificationGroup,
  getSignedInStatus,
  getSystemConfigurations,
  GetUserPermissionList,
} from "src/app/state";
import * as _ from "lodash";
import { SortDescriptor } from "@progress/kendo-data-query";
import { LWAReasonService } from "src/app/admin/lwa-reasons/shared/services/left-without-assistant-reasons.service";
import { LWAReason } from "src/app/admin/lwa-reasons/shared/models/left-without-assistant-reasion.model";

import { LobbyEntryService } from "../../shared/services/lobby-entry.service";
import * as LobbyWrapUpPageActions from "../../lobby-wrap-up/state/actions/wrap-up-page.actions";
import { State } from "src/app/state/app.state";
import { map, switchMap, take, tap } from "rxjs/operators";
import { MapSigninStatus } from "src/app/shared/mappers/signinstatus.mapper";
import * as CoreActions from "src/app/state/actions/core.actions";
import { ToastService } from "src/app/shared/services/toast.service";
import { LWAModel } from "../../lobby-central-views/shared/models/lwa-model";
import { LobbyEntryGridGroup } from "src/app/shared/models/message-hub/lobbyEntryGridGroupRequest";
import * as LobbyStaffStatusActions from "../state/actions/lobby-staff-status.actions";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { ILobbyRecord } from "../shared/models/lobby.interface";
import { IProductAndServiceRecord } from "../shared/models/product-and-service.interface";
import { LocationSelectorInfo } from "src/app/admin/user/shared/models/locationSelectorModel";
import { UserSigninStatusModel } from "../../shared/models/lobby-user-signin-status.model";
import { LocationRelationship } from "src/app/admin/location/shared/models/locationRelationship";
import { SessionService } from "src/app/shared/services/session.service";
import { LobbyService } from "../../shared/services/lobby.service";
import { SystemConfigValue } from "src/app/admin/system-configuration/shared/models/system-config-value";
import { TranslationLoaderFacade } from "src/app/admin/localization/translation-loader.facade";
import { TranslateService } from "@ngx-translate/core";
import { LobbyGridModel } from "../shared/models/lobby-grid.model";
import { LeftWithoutAssistanceComponent } from "src/app/shared/modalpopup/left-without-assistance/left-without-assistance.component";
import { LobbyEditComponent } from "src/app/shared/modalpopup/lobby-edit/lobby-edit.component";

@Component({
  selector: "app-lobby-grid",
  templateUrl: "./lobby-grid.component.html",
  styleUrls: ["./lobby-grid.component.scss"],
})
export class LobbyGridComponent implements OnInit, OnDestroy {
  public sort: SortDescriptor[] = [{ field: "WaitTime", dir: "desc" }];
  public sortingField: any = [{ field: "WaitTime", dir: "desc" }];
  public lwaPopUp: boolean = false;
  public assistPopup: boolean = false;
  public OnDemandPopup: boolean = false;
  public isMsgContentRequired: boolean = false;
  public message: string = "";
  public remainingText: number = 350;
  public dataItem: any;
  public productAndServiceView: boolean = false;
  public ShowImpersonatePopup: boolean = false;

  public lobbyGridSubscriptions = new Subscription();
  public assistingLobbyRecord: ILobbyRecord | null = null;
  public productAndServiceData: IProductAndServiceRecord =
    {} as IProductAndServiceRecord;

  public searchText: string = "";
  public currentLocationName: string = "";
  public tenantId: number = 1;
  public locationId: number = 0;
  public searchObject: LobbyEntryGridGroup = new LobbyEntryGridGroup();
  public allLWAResons: LWAReason[] = [];
  public lwaObject: LWAModel = {} as LWAModel;
  public selectedLWAResons: LWAReason[] = [];
  public isAssisting: boolean = false;
  public isImpersonateAssisting: boolean = false;

  public data: GridDataResult | null = null;
  public pageSize: number = 0;
  public skip: number = 0;
  public userPermissionList: number[] = [];
  public selectedLocationName: string = "";
  public selectedLocationId: number = 0;
  private subscriptions: Subscription = new Subscription();
  public IsSignedIn: boolean = false;
  private userId: number = 0;
  public currentLocationId: number = 0;
  public assistingLobbyEntry: any = null;
  public disableSelector: boolean = false;
  public disableSelectorNoBranch: boolean = false;
  public selectorHoverMessage: string = "";
  public staffColumnText: string = "";
  showLobbyCateogory: boolean = false;
  public enableUserImpersonation: boolean = false;
  public enableUserImpersonationForTenant: boolean = false;
  public userNotificationGroups: number[] = [];
  public assistNotificationPopup: boolean = false;
  public showAccountNumber: boolean = false;
  public currentlyAssistingText: string = "";
  public assistText: string = "";
  public alreadyAssistingText: string = "";
  public preferredLanguageId: number = 1;

  constructor(
    public lwaService: LWAReasonService,
    public lobbyEntryService: LobbyEntryService,
    public lobbyService: LobbyService,
    private store: Store<State>,
    public toastService: ToastService,
    private session: SessionService,
    private translationLoaderFacade: TranslationLoaderFacade,
    private translateService: TranslateService
  ) {
    this.subscribeToTenantAndLocation();
  }

  ngOnInit() {
    this.initializeMessageHubConnection();

    this.getSelectedLocation();

    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (allUserPermissions != undefined)
        this.userPermissionList = allUserPermissions;
    });

    const userIdSubscription = this.store
      .select(getLoggedInUserId)
      .subscribe((userId) => {
        if (userId != undefined) this.userId = userId;
      });

    const userInfoSubscription = this.store
      .select(getLoggedInUserInfo)
      .subscribe((userInfo) => {
        if (userInfo != null) {
          this.enableUserImpersonation = userInfo.enableUserImpersonation;
        }
      });

    const lobbyGridDataSubscription = this.store
      .select(getlobbyGridData)
      .subscribe((gridData) => {
        if (gridData != null) this._onReceiveData(gridData);
      });

    const signinStatusSubscription = this.store
      .select(getSignedInStatus)
      .subscribe((status: any) => {
        if (status != null && status.impersonateById != null) {
          this.isImpersonateAssisting = true;
        }

        this._onUserSignedInStatusUpdated(status);
      });

    const notificationGroupSubscriptions = this.store
      .select(getLoggedInUserNotificationGroup)
      .subscribe((notificationGroups) => {
        if (notificationGroups != undefined) {
          this.userNotificationGroups = notificationGroups;
        }
      });

    const locationSelectorStatusSubscription = this.store
      .select(getLobbyLocationSelctorStatus)
      .subscribe((status) => {
        if (status != undefined) {
          if (this.IsSignedIn && status.isError) {
            this.disableSelector = true;
            this.isAssisting = status.isAssisting;
            if (
              status.errorMessage.includes(
                "_Lobby_Cannot_Change_Single_Requested_Notification_Group_Error_Text_"
              )
            ) {
              const groupName = status.errorMessage.split("groups:")[1];
              this.selectorHoverMessage = this.translateService.instant(
                "_Lobby_Cannot_Change_Single_Requested_Notification_Group_Error_Text_",
                { value0: groupName }
              );
            } else if (
              status.errorMessage.includes(
                "_Lobby_Cannot_Change_Many_Requested_Notification_Groups_Error_Text_"
              )
            ) {
              const allGroupsAsOne = status.errorMessage.split("groups:")[1];
              const groups = allGroupsAsOne.split(",").map((g) => g.trim());
              const allButLast = groups.slice(0, -1).join(", ");
              const lastGroup = groups[groups.length - 1];
              this.selectorHoverMessage = this.translateService.instant(
                "_Lobby_Cannot_Change_Many_Requested_Notification_Groups_Error_Text_",
                { value0: allButLast, value1: lastGroup }
              );
            } else {
              this.selectorHoverMessage = status.errorMessage;
            }
          } else if (!this.disableSelectorNoBranch) {
            this.disableSelector = false;
            this.isAssisting = false;
            this.selectorHoverMessage = "";
          } else {
            this.isAssisting = false;
          }
        }
      });

    const getLobbyCategorySub = this.store
      .select(getLobbyShowCategory)
      .subscribe((lobbyCategory) => {
        this.showLobbyCateogory = lobbyCategory;
      });

    this.subscriptions.add(notificationGroupSubscriptions);
    this.subscriptions.add(locationSelectorStatusSubscription);
    this.subscriptions.add(signinStatusSubscription);
    this.subscriptions.add(userIdSubscription);
    this.subscriptions.add(getLobbyCategorySub);
    this.subscriptions.add(userInfoSubscription);
    this.subscriptions.add(
      this.store.select(getSystemConfigurations).subscribe((configurations) => {
        const lobbyConfigurations = configurations.filter(
          (c) => c.configurationGroup === "LobbySettings"
        );
        if (lobbyConfigurations.length > 0) {
          this.staffColumnText = this.readCastedValue(
            lobbyConfigurations.find(
              (ac) => ac.configurationName === "StaffStatusDisplayText"
            )
          );
          this.showAccountNumber = this.readCastedValue(
            lobbyConfigurations.find(
              (ac) => ac.configurationName === "EnableAccountNumber"
            )
          );
          this.enableUserImpersonationForTenant = this.readCastedValue(
            lobbyConfigurations.find(
              (ac) => ac.configurationName === "EnableUserImpersonation"
            )
          );
        }
      })
    );

    this.SetAcLocationState();

    this.translateService
      .get([
        "_General_Already_Assist_Text_",
        "_General_Currently_Assisting_Text_",
        "_General_Assist_Text_",
      ])
      .subscribe((res) => {
        this.alreadyAssistingText = res["_General_Already_Assist_Text_"];
        this.currentlyAssistingText = res["_General_Currently_Assisting_Text_"];
        this.assistText = res["_General_Assist_Text_"];
      });
  }

  private _onUserSignedInStatusUpdated(status: UserSigninStatusModel): void {
    this.IsSignedIn = MapSigninStatus(status);
  }

  private readCastedValue(systemConfigValue?: SystemConfigValue): any {
    if (systemConfigValue) {
      switch (systemConfigValue.dataType) {
        case "int":
          return parseInt(systemConfigValue.value, undefined);
        case "bool":
          return systemConfigValue.value === "1";
        default:
          return systemConfigValue.value;
      }
    }
  }

  private setSessionData(locaitonSelectorData: LocationSelectorInfo) {
    this.session.clearLobbyLocation();
    this.session.clearSignInSession();
    this.session.setLobbyLocation(locaitonSelectorData);

    if (locaitonSelectorData.id != undefined) {
      this.session.setSignInStatus({
        userId: this.userId as number,
        locationId: locaitonSelectorData.id,
        statusId: null,
        status: null,
        statusReason: null,
        currentAssistingLobbyEntryId: null,
        locationCode: null,
        currentAssistingLocationId: null,
        impersonateById: null,
        impersonateByName: null,
        isImpersonateOtherUser: false,
        impersonationTransferDetails: null,
      });
    }

    this.lobbyService.changeLocationChangeFlag(true);
    this.store.dispatch(
      CoreActions.updateLobbyLocationSelectorInfo({
        payload: { lobbyLocationSelectorInfo: locaitonSelectorData },
      })
    );
    this.store.dispatch(
      CoreActions.updateACLocationSelectorInfo({
        payload: { acLocationCode: locaitonSelectorData.locationCode },
      })
    );
    this.store.dispatch(
      LobbyStaffStatusActions.updateLobbyGrid({
        gridData: this.getLobbyCentralGridViewDataForInitially(),
      })
    );
  }

  public handleLocationData(locaitonSelectorData: LocationSelectorInfo): void {
    if (!this.IsSignedIn) {
      this._ShowUserSigninPrompt();
      this.setSessionData(locaitonSelectorData);
    } else {
      if (locaitonSelectorData.id != undefined) {
        this.lobbyService
          .changeSignInBranch({
            userId: this.userId as number,
            locationId: locaitonSelectorData.id,
            branchId: this.locationId,
          })
          .subscribe({
            next: () => {
              this.setSessionData(locaitonSelectorData);
              if (locaitonSelectorData.id != undefined) {
                this.store.dispatch(
                  CoreActions.loadSignInDetailsForUser({
                    payload: {
                      userId: this.userId as number,
                      tenantId: this.tenantId,
                      locationId: locaitonSelectorData.id,
                    },
                  })
                );
                const translatedToastMsg = this.translateService.instant(
                  "_General_Signed_Into_Ts_Text_"
                );
                this.toastService.showSuccess(
                  translatedToastMsg + " " + locaitonSelectorData.locationName
                );
              }
            },
            error: () => {
              this.toastService.showError(
                "_General_Changing_Signed_Location_Failed_Ts_Text_"
              );
            },
          });
      }
    }
  }
  private SetAcLocationState() {
    const locationACCodeSubscription = this.store
      .select(getLobbyLocationSelected)
      .pipe(take(1))
      .subscribe((location) => {
        if (
          location.locationCode !== undefined &&
          location.locationCode !== null
        ) {
          this.store.dispatch(
            CoreActions.updateACLocationSelectorInfo({
              payload: { acLocationCode: location.locationCode },
            })
          );
        }
      });

    this.subscriptions.add(locationACCodeSubscription);
  }
  // Prompt the user signin popup
  private _ShowUserSigninPrompt(): void {
    this.store.dispatch(
      CoreActions.promptUserToSignin({ payload: { isSelectorChange: true } })
    );
  }
  /**
   * Open Text On Demand Pop Up
   * @param dataItem
   */
  public openTextOnDemandPopup(dataitem: any) {
    this.dataItem = dataitem;
    this._showUnableToSigninPopup().subscribe((branchesAvailable) => {
      if (branchesAvailable) {
        this._showSigninPopupIfNotSignedInAlready().subscribe(
          (status: boolean) => {
            if (status) {
              this.OnDemandPopup = true;
            }
          }
        );
      }
    });
  }

  /**
   * Close Text On Demand Pop Up
   */
  public closeOnDemandTextPopop() {
    this.message = "";
    this.remainingText = 350;
    this.OnDemandPopup = this.isMsgContentRequired = false;
  }

  /**
   *  * Triggers when clicking Send in the Text On Demand Pop Up
   */
  public SendTextOnDemandMessage(value?: string) {
    const valueNoWhiteSpace = value?.trim();

    if (valueNoWhiteSpace == "") {
      this.isMsgContentRequired = true;
    } else {
      this.isMsgContentRequired = false;
      this.store.select(getLoggedInUserId).subscribe((userId) => {
        this.lobbyEntryService
          .sendTextOnDemand(this.dataItem.lobbyEntryId, this.message, userId)
          .subscribe(
            (onDemandData) => {
              this.toastService.showSuccess(
                "_General_Message_Sent_Successfully_Ts_Text_"
              );
              this.closeOnDemandTextPopop();
            },
            (error) => {
              this.toastService.showError(
                "_General_Failed_Message_Request_Ts_Text_"
              );
              this.closeOnDemandTextPopop();
            }
          );
      });
    }
  }

  public GetRemaningTextCount(value: number) {
    if (value === 0) {
      this.message = "";
      this.isMsgContentRequired = true;
    } else {
      this.isMsgContentRequired = false;
    }

    this.remainingText = 350 - value;
  }
  public getSelectedLocation() {
    //Set signed in users home location as the default location when loading the location grid
    const locationCodeSubscription = this.store
      .select(getLobbyLocationSelected)
      .subscribe((location) => {
        if (location.locationId !== undefined && location.locationId !== null) {
          this.selectedLocationName = location.locationName;
          this.selectedLocationId = location.locationId;
          this.disableSelectorNoBranch = location.dropDownDisabled;
        }
      });

    this.subscriptions.add(locationCodeSubscription);
  }

  /**
   *  Subscribe to tenant and location form root store
   */
  public subscribeToTenantAndLocation() {
    const tenantSelectionSub = this.store
      .select(getCurrentTenant)
      .subscribe((tenant) => {
        if (tenant) {
          this.tenantId = tenant.tenantID;
        }
      });
    const locationSub = this.store
      .select(getLobbyLocationSelected)
      .subscribe((location) => {
        if (location.locationId !== undefined && location.locationId !== 0) {
          this.locationId = location.locationId;
        }
      });
    this.lobbyGridSubscriptions.add(tenantSelectionSub);
    this.lobbyGridSubscriptions.add(locationSub);
  }

  /**
   * Sets default values in lobby grid
   */
  private _setDefaultValues() {
    this.sort = [{ field: "WaitTime", dir: "desc" }];
    this.pageSize = 25;
    this.skip = 0;
    this.searchText = "";
  }

  /**
   * Triggers after recieveing grid data
   * @param gridData
   */
  private _onReceiveData(gridData: LobbyGridModel) {
    if (gridData) {
      this.data = {
        data: gridData.data ?? [],
        total: gridData.totalRowCount ?? 0,
      };
      this.pageSize = gridData.pageSize ?? 1;
      this.skip = (gridData.currentPageNumber - 1) * this.pageSize;
    } else {
      this._setDefaultValues();
    }
  }

  /**
   * Initialize SignalR Connection and Subscribe
   */
  public initializeMessageHubConnection() {
    const signalRConnectionSubscription = this.store
      .select(getIsConnectionStarted)
      .subscribe((isHubConnected) => {
        if (isHubConnected) {
          this.store.dispatch(
            LobbyStaffStatusActions.updateLobbyGrid({
              gridData: this.getLobbyCentralGridViewDataForInitially(),
            })
          );
        }
      });
    this.lobbyGridSubscriptions.add(signalRConnectionSubscription);
  }

  /**
   * Generate central lobby initial request
   */
  public getLobbyCentralGridViewDataForInitially() {
    const initialSearchObject: LobbyEntryGridGroup = {
      LanguageKey: "",
      LocationId: this.locationId,
      Page: 1,
      PageSize: 10,
      SearchText: "",
      SortColumn: this.sortingField[0].field,
      SortDirection: this.sortingField[0].dir === "asc" ? "asc" : "desc",
      TenantId: this.tenantId,
      UserRequested: null,
      PreferredLanguageId: 1,
    };

    this.store.select(getLoggedInUserInfo).subscribe((user) => {
      if (user !== undefined && user !== null && user["preferredLanguage"]) {
        initialSearchObject.PreferredLanguageId = user["preferredLanguage"];
      }
    });

    // TODO: This is problematic, change the JSON parsing after checking the runtime behavior.
    this.searchObject = JSON.parse(JSON.stringify(initialSearchObject));
    return initialSearchObject;
  }

  /**
   * Triggers when user click the search button.
   *
   */
  public searchKeyWordChange() {
    console.log(this.searchText);
    this.store.dispatch(
      LobbyStaffStatusActions.updateLobbyGrid({
        gridData: Object.assign({}, this.searchObject, {
          SearchText: this.searchText,
        }),
      })
    );
  }

  /**
   * Triggers when user click the clear search button.
   */
  public clearSearchFilter() {
    this.searchText = "";
    this.store.dispatch(
      LobbyStaffStatusActions.updateLobbyGrid({
        gridData: Object.assign({}, this.searchObject, {
          SearchText: this.searchText,
        }),
      })
    );
  }

  /**
   * Triggers when user changes the page of the grid
   * @param event
   */
  public onPageChange(event: any) {
    this.store.dispatch(
      LobbyStaffStatusActions.updateLobbyGrid({
        gridData: Object.assign({}, this.searchObject, {
          Page: event.skip / event.take + 1,
          PageSize: event.take,
        }),
      })
    );
  }

  /**
   * Triggers when sort changed by the user
   * @param sort
   */
  public sortChange(sort: SortDescriptor[]) {
    this.sort = sort;
    switch (sort[0].field) {
      case "accountNumber":
        this.sortingField[0].field = "AccountNumber";
        break;
      case "firstName":
        this.sortingField[0].field = "FirstName";
        break;
      case "lastName":
        this.sortingField[0].field = "LastName";
        break;
      case "personRequested":
        this.sortingField[0].field = "PersonRequested";
        break;
      case "serviceRequested":
        this.sortingField[0].field = "ServiceRequested";
        break;
      case "WaitTime":
        this.sortingField[0].field = "WaitTime";
        break;
    }

    let newSearchObject = _.cloneDeep(this.searchObject);
    newSearchObject!.SortColumn = this.sortingField[0].field;
    newSearchObject!.SortDirection = sort[0].dir as string;
    this.searchObject = newSearchObject;
    this.store.dispatch(
      LobbyStaffStatusActions.updateLobbyGrid({
        gridData: newSearchObject,
      })
    );
  }

  /**
   * Close LWA popup and empty the selected reasons
   */
  public closeLeftWithoutAssistant() {
    this.lwaPopUp = false;
    this.selectedLWAResons = [];
  }

  /**
   * Fetches all the LWA options
   * @param event
   */
  public openLeftWithoutAssistant(event: any) {
    console.log(event);
    if (event.firstName && event.lastName && event.locationName) {
      this.lwaObject = {
        firstName: event.firstName,
        lastName: event.lastName,
        locationName: event.locationName,
      };
      this.lwaService.getLwaReasons().subscribe((allLWAdata: LWAReason[]) => {
        this.allLWAResons = allLWAdata;
        this.lwaPopUp = true;
      });
    }
  }

  public checkedChangedEvent(event: any, i: any) {
    if (event.currentTarget.checked) {
      this.selectedLWAResons.push(i);
    } else {
      let foundIndex = this.selectedLWAResons.findIndex(
        (item) => item === i.id
      );
      this.selectedLWAResons.splice(foundIndex, 1);
    }
  }

  /**
   * Open LWA popup which is in the shared folder.
   * @param popUp
   * @param dataItem
   */
  public openPopUp(popUp: LeftWithoutAssistanceComponent, dataItem: any) {
    this._showUnableToSigninPopup().subscribe((branchesAvailable) => {
      if (branchesAvailable) {
        this._showSigninPopupIfNotSignedInAlready().subscribe(
          (status: boolean) => {
            if (status) {
              let lwaObject = {
                firstName: dataItem.firstName,
                lastName: dataItem.lastName,
                locationName: dataItem.locationName,
              };
              popUp.open();
              popUp.lwaObject = lwaObject;
              popUp.dataItem = dataItem;
            }
          }
        );
      }
    });
  }

  /**
   * Open the shared Lobby Edit Pop Up
   * @param popUp
   * @param dataItem
   */

  public openLobbyEdit(popUp: LobbyEditComponent, dataItem: any) {
    popUp.dataItem = dataItem;
    this._showUnableToSigninPopup().subscribe((branchesAvailable) => {
      if (branchesAvailable) {
        this._showSigninPopupIfNotSignedInAlready().subscribe(
          (status: boolean) => {
            if (status) {
              popUp.open();
            }
          }
        );
      }
    });
  }

  /**
   * Open assisting Popup
   * @param event
   */
  // TODO: Sign-in prompting behavior should be addressed within sign-in-popup service.

  public openImpersonateAssist(data: any) {
    this._showUnableToSigninPopup().subscribe((branchesAvailable) => {
      if (branchesAvailable) {
        this._showSigninPopupIfNotSignedInAlready().subscribe(
          (status: boolean) => {
            if (status) {
              this.currentLocationName = data?.locationName;
              this.currentLocationId = data?.locationId;
              this.assistingLobbyEntry = data;
              this.store.dispatch(
                LobbyStaffStatusActions.loadImpersonateUsers({
                  locationId: this.currentLocationId,
                  showPopUp: true,
                })
              );
            }
          }
        );
      }
    });
  }

  public openAssist(event: any) {
    this.assistingLobbyRecord = event;
    this._showUnableToSigninPopup().subscribe((branchesAvailable) => {
      if (branchesAvailable) {
        this._showSigninPopupIfNotSignedInAlready().subscribe(
          (status: boolean) => {
            if (status) {
              this.store
                .select(getLoggedInUserId)
                .subscribe((userId?: number) => {
                  if (
                    userId != undefined &&
                    this.assistingLobbyRecord !== null &&
                    (userId === this.assistingLobbyRecord.personRequestedId ||
                      this.assistingLobbyRecord.personRequestedId === null)
                  ) {
                    if (
                      this.assistingLobbyRecord &&
                      this.assistingLobbyRecord.groupRequestedId > 0 &&
                      this.userNotificationGroups?.indexOf(
                        this.assistingLobbyRecord.groupRequestedId
                      ) === -1
                    ) {
                      this.assistNotificationPopup = true;
                    } else {
                      this.store.dispatch(
                        LobbyWrapUpPageActions.assistLobbyEntry({
                          lobbyEntryId: this.assistingLobbyRecord.lobbyEntryId,
                          assistingUserId: userId,
                          isInstantAssist: false,
                          locationId: this.locationId,
                          showLobbyCategory: this.showLobbyCateogory,
                          isImpersonateAssist: false,
                          impersonateByName: null,
                        })
                      );

                      this.assistingLobbyRecord = null;
                    }
                  } else {
                    this.assistPopup = true;
                  }
                });
            }
          }
        );
      }
    });
  }

  /**
   * Show sign in user popup
   * @returns
   */

  // TODO: Refactor and move into sign-in-popup service
  private _showSigninPopupIfNotSignedInAlready(): Observable<boolean> {
    return this.store.select(getSignedInStatus).pipe(
      map((signInStatus) =>
        MapSigninStatus(signInStatus as UserSigninStatusModel)
      ),
      take(1), // This would remove the need for the subscriber to unsubscribe
      tap((status) => {
        if (!status) {
          this.store.dispatch(
            CoreActions.promptUserToSignin({
              payload: { isSelectorChange: false },
            })
          );
        }
      })
    );
  }

  // TODO: Refactor and move into sign-in-popup service
  private _showUnableToSigninPopup(): Observable<boolean> {
    return this.store.select(getAvailableActiveBranches).pipe(
      take(1),
      tap((b: LocationRelationship[]) => {
        if (b.length == 0)
          this.store.dispatch(CoreActions.promptUnableToSignin());
      }),
      switchMap((b) => of(b.length > 0))
    );
  }

  /**
   * Triggers when submitting No in the assist popup
   */
  public submitNo() {
    this.assistPopup = false;
    this.assistNotificationPopup = false;
  }

  /**
   * Triggers when submitting Yes in the assist popup
   * Calls Wrap up popup
   */
  public submitYes() {
    this.assistPopup = false;
    this.assistNotificationPopup = false;
    this.store.select(getLoggedInUserId).subscribe((userId) => {
      if (userId != null && this.assistingLobbyRecord != null) {
        this.store.dispatch(
          LobbyWrapUpPageActions.assistLobbyEntry({
            lobbyEntryId: this.assistingLobbyRecord.lobbyEntryId,
            assistingUserId: userId,
            isInstantAssist: false,
            locationId: this.locationId,
            showLobbyCategory: this.showLobbyCateogory,
            isImpersonateAssist: false,
            impersonateByName: null,
          })
        );
      } else
        throw new Error(
          `[lobby/lobby-staff-status/lobby-grid/lobby-grid.component]: Unexpected code path reached. One or all of 'assistingLobbyEntry', 'assistingLobbyRecord', 'userId' was null.`
        );
    });
  }

  /**
   * Closes product and service dialog
   * Triggered by clicking on + Icon in the lobby grid.
   */
  public closeProductServiceDialog() {
    this.productAndServiceView = false;
  }

  /**
   * Open product and service dialog
   * Triggers by clicking on + Icon in the lobby grid.
   */
  public openProductServiceDialog() {
    this.productAndServiceView = true;
  }

  /**
   * Fetches data of the product and service requested
   * @param event
   */
  public productClickedHandler(event: any) {
    this.lobbyEntryService
      .getLobbyEntryDetails(event.lobbyEntryId)
      .subscribe((lobbyEntryData) => {
        this.productAndServiceData = lobbyEntryData;
        this.openProductServiceDialog();
      });
  }

  /**
   * Show toast error messages
   */
  public toastError() {
    this.toastService.show("_General_Currently_Assisting_Text_", {
      classname: "cc-alert-danger cc-alert ",
      delay: 3500,
      autohide: true,
    });
  }

  /**
   * Destroy the subscription.
   */
  ngOnDestroy() {
    this.lobbyGridSubscriptions.unsubscribe();
    const groupNames = ["LobbyEntryGridGroup"];
    this.store.dispatch(
      CoreActions.unsubscribeFromSignalRGroups({ groupNames })
    );
  }

  public updateRemoteCheckedInVisitorStatus(event: any, isArrived: boolean) {
    this._showSigninPopupIfNotSignedInAlready().subscribe((status: boolean) => {
      if (status) {
        this.store.dispatch(
          LobbyWrapUpPageActions.isVisitorArrived({
            lobbyEntryId: event.lobbyEntryId,
            isArrived: isArrived,
          })
        );
      }
    });
  }
}
